export default {
  links: {},
  segments: [],
  subscription: {},
  functionalities: [],
  functionalitiesBlockedByAdmin: [],
  isLoadingFunctionalities: false,
};
